const authType = {
  FETCHING: "AUTH_FETCHING",
  ACTION_LOADER: "AUTH_ACTION_LOADER",
  CHANGE_ROLE: "AUTH_CHANGE_ROLE",
  SET_USER: "AUTH_SET_USER",
};

export default authType;
